/** Mirrors the BFF context selection contract; shared fixtures guard parity. */
export function pickActiveApplication<T extends {
  status?: unknown;
  stageIsTerminal?: unknown;
  appUpdatedAt?: unknown;
}>(rows: T[]): T | undefined {
  const terminal = ['rejected', 'withdrawn', 'cancelled', 'lapsed', 'completed'];
  const nonTerminal = rows.filter(
    (row) => row.stageIsTerminal !== true && !terminal.includes(String(row.status ?? '').toLowerCase()),
  );
  const newest = [...nonTerminal].sort((a, b) =>
    String(b.appUpdatedAt ?? '').localeCompare(String(a.appUpdatedAt ?? '')),
  );
  // Preserve the explicit legacy fallback when there is no active application.
  return newest.length > 0 ? newest[0] : rows.length > 0 ? rows[0] : undefined;
}
